import {usePage} from '@inertiajs/inertia-vue3';

export default function UserCan(permissions) {
    let result = false
    const roles = usePage().props.value.auth.roles;
    if(typeof permissions === "object") {
        permissions.forEach(permission => {
            roles.forEach(role => {
                if( result === false ) {
                    const search = role.permissions.find(rolePermission => {
                        return rolePermission.name === permission
                    })
                    result = typeof search !== "undefined"
                }
            })
        });
    }
    return result
}
